import { render, staticRenderFns } from "./ProfileAccountSettings.vue?vue&type=template&id=172342b8&scoped=true"
import script from "./ProfileAccountSettings.vue?vue&type=script&lang=ts"
export * from "./ProfileAccountSettings.vue?vue&type=script&lang=ts"
import style0 from "./ProfileAccountSettings.vue?vue&type=style&index=0&id=172342b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172342b8",
  null
  
)

export default component.exports